import AppRelease from '@/modules/app-router/model/AppRelease'
import UserGroup from '@/modules/user/model/UserGroup'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Asignación de una distribución para un grupo de usuarios
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class GroupReleaseAssignation {
    public readonly originalRelease: AppRelease | null;

    constructor (release = new AppRelease(), group = new UserGroup()) {
        this.originalRelease = release
        this.release = release
        this.group = group
    }
    /**
     * Identificador de la asignación
     */
    public id = 0

    /**
     * Distribución a la que accederán los usuarios del grupo
     */
    public release = new AppRelease()

    /**
     * Grupo de usuarios
     */
    public group = new UserGroup()

    /**
     * Crea una entidad a partir de un objeto serializado enviado por la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const assignation = new this(
            AppRelease.deserialize(data.release),
            UserGroup.deserialize(data.group),
        )

        assignation.id = data.id

        return assignation
    }

    /**
     * Crea un objeto plano a partir de la entidad.
     */
    public serialize () {
        return {
            group: this.group.id,
            release: this.release ? this.release.id : null,
        }
    }
}
